import { Outlet, useNavigate } from "react-router-dom";
import { usePermissions } from "../../hooks/usePermissions";
import AccessRestricted from "./AccessRestricted";

const AdminGuard = () => {
  const { isAdmin, groups } = usePermissions();
  const navigate = useNavigate();

  if (!isAdmin) {
    return (
      <AccessRestricted
        badge="Área Administrativa"
        message="Esta área é restrita apenas para administradores do sistema."
        secondaryMessage="Se você acredita que deveria ter acesso, entre em contato com um administrador."
        secondaryButton={{
          label: "Ir para Dashboard",
          onClick: () => navigate("/"),
        }}
        debugInfo={`Grupos: ${JSON.stringify(groups)}`}
      />
    );
  }

  return <Outlet />;
};

export default AdminGuard;
